const getDetailsFromIp = async () => {
    try {
        let response = await fetch('https://ipapi.co/json/');
        if (!response.ok) {
            console.error('Failed to fetch IP details:', response.statusText);
            return null;
        }
        let data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching IP details:', error);
        return null;
    }
};

const authMethods = {
    getDetailsFromIp
};

export default authMethods;
